import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { sendTestmailResolver } from '@adornis/mails/server/resolver.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { hasPermission } from '@ils/permissions/hasPermission.js';
import { ilsRecipients } from '../recipients.js';
import { mailer } from '../server/mailer.js';

export const sendTestMailToCurrentUser = registerMutation({
  operationName: 'sendTestMailToCurrentUser',
  type: () => Boolean,
  resolve: (emailType: string, scope?: string) => async () => {
    const user = await CurrentUserInfo.getMyself()({ _id: 1, email: 1, roles: { name: 1, contexts: 1 } });
    if (!user || !hasPermission(user, 'mails', 'view')) throw new Error('not authorized');
    await sendTestmailResolver({
      recipient: ilsRecipients(user.email),
      mailer,
      mailType: emailType,
      scope,
    });
    return true;
  },
  params: [
    { name: 'mailType', type: () => String },
    { name: 'scope', type: () => String },
  ],
});
